var ErrorEnum;
(function (ErrorEnum) {
  ErrorEnum["safBackToTop"] = "<saf-back-to-top> expects to have one <a> with an href attribute";
  ErrorEnum["safBreadcrumbs"] = "<saf-breadcrumbs> expects to have a <nav aria-label=\"Breadcrumbs\"> as first child, followed by a <ul> having as many <li> tags that are requested depending on the number of links that are going to be rendered ";
  ErrorEnum["safButton"] = "<saf-button> expects either <button> or <a> as a child";
  ErrorEnum["safCard"] = "<saf-card> expects either <div> or <a> as a child";
  ErrorEnum["safCardContent"] = "<saf-card-content> expects a <div> as a child";
  ErrorEnum["safCardMedia"] = "<saf-card-media> expects an <img> as a child";
  ErrorEnum["safCheckbox"] = "<saf-checkbox> expects an the following format: <saf-checkbox /> <input /> <label /> <span slot=\"extra-info\" /> <span slot=\"error-message\" /> <saf-icon />";
  ErrorEnum["safChip"] = "<saf-chip> expects a <input type=\"checkbox\"> and a <label> as children";
  ErrorEnum["safComparisonMatrix"] = "<saf-comparison-matrix> expects a <table> as a child";
  ErrorEnum["safContentControls"] = "<saf-content-controls> expects the following format: <saf-button data-name=\"previous\"/> <span/> <saf-button data-name=\"next\"/>";
  ErrorEnum["safDividerHorizontal"] = "<saf-divider> expects a <hr> as a child, when set to horizontal orientation";
  ErrorEnum["safDividerVertical"] = "<saf-divider> expects a <div> as a child, when set to vertical orientation";
  ErrorEnum["safForm"] = "<saf-form> expects a <label /> and either an <input />, <select />, or <textarea /> ";
  ErrorEnum["safIcon"] = "<saf-icon> expects an <svg> as a child";
  ErrorEnum["safInputPw"] = "<saf-input-password> expects a <saf-input-text semantic> as a child, with its correct format.";
  ErrorEnum["safInputText"] = "<saf-input-text> expects the following format: <label /> <input /> <* slot=\"after\" /> (optional) <span slot=\"helper-text\" /> (optional)";
  ErrorEnum["safLink"] = "<saf-link> expects an <a> as a child";
  ErrorEnum["safPriceRange"] = "<saf-price-range> expects the following format: <saf-typography data-name=\"label\"/> <span data-name=\"title\"/>";
  ErrorEnum["safRadioButton"] = "<saf-radio-button> expects an the following format: <saf-radio-button /> <input /> <label /> <span slot=\"extra-info\" /> <span slot=\"error-message\" /> <saf-icon />";
  ErrorEnum["safRadioButtonGroup"] = "<saf-radio-button-group> expects the following format: <saf-radio-button-group /> <fieldset /> <legend /> more than 1 <saf-radio-button /> <span slot=\"extra-info\" /> <span slot=\"error-message /> <saf-icon />";
  ErrorEnum["safSelect"] = "<saf-select> expects a <label> and a <select> as children";
  ErrorEnum["safSvg"] = "<saf-svg> expects an <svg> as a child";
  ErrorEnum["safSvgStoreId"] = "<saf-svg> requires the svgData being passed to have a unique `id` when the `isStore` property is set to true";
  ErrorEnum["safTag"] = "<saf-card> expects either <p> or <span> as a child";
  ErrorEnum["safTextArea"] = "<saf-textarea> expects the following format: <label /> <textarea />";
  ErrorEnum["safTypography"] = "<saf-typography> expects at least one of <p>, <h1>, <h2>, <h3>, <h4>, <h5>, <h6>, <ul>, or <ol>";
  ErrorEnum["safNavOption"] = "<saf-nav-option> expects either a <a> or <button> as a child";
  ErrorEnum["safShareLinks"] = "<saf-share-links> expect a set of <a> with the href attribute";
  ErrorEnum["safStickyNav"] = "<saf-sticky-nav> expects a <nav> element as child";
})(ErrorEnum || (ErrorEnum = {}));
const ErrorEnum$1 = ErrorEnum;

const sendError = (msg) => console.error(msg);
const testChild = (child, errorEnum, renderFunction) => {
  if (child) {
    if (renderFunction) {
      renderFunction();
    }
  }
  else {
    sendError(errorEnum);
  }
};
const testChildren = (children, errorEnum, renderFunction) => {
  if (children.length > 0 && children.every(child => child)) {
    if (renderFunction)
      renderFunction();
  }
  else {
    sendError(errorEnum);
  }
};

export { ErrorEnum$1 as E, testChildren as a, testChild as t };

